/* eslint-disable */
import { Box, Button, LinearProgress, Switch, Typography } from '@mui/material'
import { DataGrid, GridCellParams, GridToolbar } from '@mui/x-data-grid'
import {
  Delete as DeleteIcon,
  Upload as UploadIcon,
  Description as FileIcon,
  PictureAsPdf as PdfIcon,
  Download as DownloadIcon,
} from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import ActionDialog from './ActionDialog'
import { useApiGet, useApiPost } from '../../apiCalls/useApi'
import { getBreachAction, updateBreachPhaseStatus } from '../../apiCalls/breachApi'

export default function StatusAndList({ phase, breachId, breachInfo, setNeedUpdate }: any) {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const [selectedAction, setSelectedAction] = useState<any>(null)
  const [data, setData] = useState<any>([])
  const fetchBreachAction = useApiGet(getBreachAction)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [updateFlag, setUpdateFlag] = useState<number>(0)

  useEffect(() => {
    setIsLoading(true)
    fetchBreachAction({ breachId, phase }).then((res) => {
      if (!res || !res?.data || res.error) return
      setData(res.data)
      setIsLoading(false)
    })
  }, [breachId, phase, updateFlag])

  const processPhaseStatus = () => {
    const statusKey =
      phase
        .split('_')
        .map((word: string, index: number) =>
          index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join('') + 'Status'

    if (breachInfo[statusKey] === 'true') {
      return true
    } else {
      return false
    }
  }

  const getAttachementNameAndType = (attachment: any) => {
    const name = attachment?.filename || ''
    const type = name ? name.split('.').pop() : ''
    return { name, type }
  }

  const updatePhaseStatus = useApiPost(updateBreachPhaseStatus)

  const handleUpdatePhaseStatus = (status: boolean) => {
    console.log('show status',status)
    updatePhaseStatus({
      statusType: phase,
      breachId,
      status,
    }).then((res: any) => {
      if (res?.error) return
      setNeedUpdate((prev:any) => prev + 1)
    })
  }

  const renderAttachments = (attachments: any) => {
    return (
      <>
        <Box
          sx={{
            height: '90px',
            borderRadius: '4px',
            overflow: 'auto',
            p: 2,
          }}
        >
          {attachments.map((attachment: any) => (
            <Box
              key={attachment.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                py: 1,
                borderBottom: '1px solid #f0f0f0',
              }}
            >
              <Box>
                {getAttachementNameAndType(attachment).type === 'pdf' ? (
                  <PdfIcon color='error' />
                ) : (
                  <FileIcon color='primary' />
                )}
              </Box>

              <Typography sx={{ flex: 1 }}>{getAttachementNameAndType(attachment).name}</Typography>
            </Box>
          ))}
        </Box>
      </>
    )
  }
  const columns = [
    {
      field: 'actionName',
      headerName: 'Actions',
      flex: 0.3,
      renderCell: (params: GridCellParams) => {
        return (
          <div
            className='linkStyle'
            onClick={() => {
              setSelectedAction(params.row)
              setDialogOpen(true)
            }}
          >
            {params.row.actionName}
          </div>
        )
      },
    },
    { field: 'timestamp', headerName: 'Timestamp', flex: 0.2 },
    { field: 'username', headerName: 'User Name', flex: 0.2 },
    { field: 'description', headerName: 'Description', flex: 0.6 },
    { field: 'notes', headerName: 'Notes', flex: 0.6 },
    {
      field: 'attachments',
      headerName: 'Attachments',
      flex: 0.5,
      renderCell: (params: GridCellParams) => {
        return renderAttachments(params.row.attachments)
      },
    },
  ]
  return (
    <Box
      sx={{
        padding: '10px',
        height: '98%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex', gap: '20px', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Typography sx={{ fontSize: '14px', fontWeight: 'bold', color: '#5B5B5B' }}>
            In Progress
          </Typography>
          <Switch checked={processPhaseStatus()} onChange={(e, checked) => handleUpdatePhaseStatus(checked)} />
          <Typography sx={{ fontSize: '14px', fontWeight: 'bold', color: '#5B5B5B' }}>
            Completed
          </Typography>
        </div>
        <Button
          variant='contained'
          onClick={() => {
            setSelectedAction(null)
            setDialogOpen(true)
          }}
          sx={{ backgroundColor: '#1976d2', color: 'white', fontSize: '14px', fontWeight: 'bold' }}
        >
          Add Action
        </Button>
        <ActionDialog
          phase={phase}
          breachId={breachId}
          setUpdateFlag={setUpdateFlag}
          open={dialogOpen}
          onClose={() => {
            setDialogOpen(false)
            setSelectedAction(null)
          }}
          data={selectedAction}
        />
      </Box>
      <Box sx={{ marginTop: '20px', flexGrow: 1, overflow: 'auto' }}>
        <DataGrid
          loading={isLoading}
          hideFooterSelectedRowCount
          slots={{
            loadingOverlay: LinearProgress,
            toolbar: GridToolbar,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: false,
            },
          }}
          columns={columns}
          getRowId={(row) => row.id}
          rows={data || []}
          rowHeight={110}
          sx={{
            border: 0,
            '& .MuiDataGrid-row:hover': {
              backgroundColor: 'rgba(235, 235, 235, 0.7)',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#FFFFFF',
              color: '#5B5B5B',
              fontSize: '15px',
              fontFamily: 'Segoe UI',
              borderBottom: '2px solid #BABABA',
            },
            '& .MuiDataGrid-cell': {
              borderBottom: `1px solid #BABABA`,
              fontSize: '12px',
              cursor: 'pointer',
              fontFamily: 'Segoe UI',
              fontWeight: '600',
            },
            '& .MuiDataGrid-columnSeparator': {
              display: 'none',
            },
            '& ::-webkit-scrollbar': {
              width: '5px',
            },
            '& ::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1',
            },
            '& ::-webkit-scrollbar-thumb': {
              backgroundColor: '#888',
              borderRadius: '5px',
              '&:hover': {
                backgroundColor: '#555',
              },
            },
            '& .MuiDataGrid-toolbarContainer .MuiButtonBase-root': {
              color: '#5B5B5B',
            },
            '& .MuiDataGrid-toolbarContainer .MuiSvgIcon-root': {
              fill: '#5B5B5B',
            },
          }}
        />
      </Box>
    </Box>
  )
}
